import * as types from 'constants/publicDownloadsActionTypes';

const initialState = {
  loading: false,
  data: [],
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_LIST_PUBLIC_DOWNLOADS_LOADING: {
      return { ...state, loading: true, error: null };
    }
    case types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS: {
      const { response } = action;
      return { ...state, loading: false, data: response, error: null };
    }
    case types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE: {
      const { error } = action;
      return { ...state, loading: false, error };
    }
    default:
      return state;
  }
};
